import { Heading } from '@navikt/ds-react';

const PageNotFound = () => (
    <div className="notfound__container">
        <Heading size={'large'} level={'1'}>
            404
        </Heading>
    </div>
);
export default PageNotFound;
